import type { PublishedTeam } from '@tempo-io/roadmap-dto';
import { usePublishedContext } from '@/components/views/published/PublishedContext';
import { usePublishedSnapshotQuery } from '@/components/views/published/usePublishedSnapshotQuery';
import type { Team } from '@/lib/api/types/teams';
import { useGetTeamsQuery } from '@/lib/queries/teams/useGetTeamsQuery';
import { teamsQueryKeys } from '@/lib/query-keys/teams';

function mapPublishedTeam(t: PublishedTeam): Team {
  return {
    id: t.id,
    name: t.name,
    color: t.color ?? '',
    totalCapacitySeconds: null,
    createdAt: '',
    updatedAt: '',
    description: null,
  };
}

export const useTeamsQueryWithPublished = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const teamsQuery = useGetTeamsQuery({ enabled: !isPublished && enabled });

  const publishedQuery = usePublishedSnapshotQuery({
    baseKey: teamsQueryKeys.all(),
    getSnapshot: () => publishedContext?.teams.map(mapPublishedTeam),
  });

  if (isPublished) return publishedQuery;
  return { ...teamsQuery, data: teamsQuery.data?.data };
};
